<template>
  <banners
    :sticky-top="true"
    :narrow="true"
  >
    <div class="flex h-[calc(100vh-52px)] w-full">
      <div
        :class="{
          'relative w-[900px] overflow-scroll': isDesktop,
          'w-full': !isDesktop,
        }"
      >
        <div class="mx-4 mb-3 mt-6 bg-white">
          <div class="container-max m-auto">
            <div class="flex items-center justify-between">
              <router-link
                :to="backUrl"
                title="Back to Loads"
                class="-ml-2 flex max-w-[66%] items-center"
              >
                <svg
                  class="min-w-7"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 10.8906L13 16.8906L19 22.8906"
                    stroke="#313545"
                    stroke-width="2"
                  />
                </svg>
                <p
                  class="overflow-hidden text-ellipsis whitespace-nowrap text-2xl"
                >
                  {{ isDesktop ? 'Load ' : ''
                  }}{{ load.shipment_identifier || load?.external_id }}
                </p>
              </router-link>

              <div v-if="!isLoadBoard">
                <p
                  class="rounded-full px-2 text-sm capitalize"
                  :class="{
                    'bg-yellow-100 text-yellow-700': load.status === 'covered',
                    'bg-blue-100 text-blue-500': load.status === 'progress',
                    'bg-green-100 text-green-800':
                      load.status === 'assumed_delivered',
                    'bg-red-150 text-red-500':
                      load.status === 'assign_vehicle' ||
                      load.status === 'available',
                  }"
                >
                  {{ formatLoadStatus(load.status) }}
                </p>
              </div>
            </div>

            <div
              v-if="!isLoadBoard"
              class="flex justify-between gap-4 pt-4 lg:mt-4 lg:w-24"
            >
              <span
                v-for="tab in tabs"
                :key="tab.title"
                class="mx-2 flex-1 cursor-pointer"
                :class="
                  currentTab === tab.title
                    ? 'border-b-2 border-neutral-subtle-yellow text-base text-neutral-subtle-yellow'
                    : 'text-base text-gray-300'
                "
                @click="handleTabSelection(tab.title)"
              >
                <p class="text-base">
                  {{ tab.title }}
                </p>
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="isLoading"
          class="mt-6"
        >
          <img
            class="loading m-auto h-12 w-12"
            src="@/assets/loading-v2-yellow.svg"
            alt="loading spinner"
          />
        </div>
        <div v-else-if="currentTab === 'Details'">
          <LoadDetailMap
            v-if="!loadDetailsLoading && !isDesktop"
            :load="load"
          ></LoadDetailMap>

          <div class="bg-light-gray px-4 pb-8 lg:bg-white lg:pb-0">
            <div class="container-max m-auto flex min-h-[80vh] flex-col gap-4">
              <div
                v-if="isLoadBoard"
                :class="{
                  'z-10 -mt-8 rounded-xl border border-light-gray bg-white px-4 py-2 shadow-md lg:mt-4':
                    !isDesktop,
                }"
              >
                <div
                  :class="{
                    'rounded-lg border border-light-gray px-3': isDesktop,
                  }"
                >
                  <div
                    v-if="isDesktop"
                    class="mt-4 flex flex-col items-start gap-2"
                  >
                    <span
                      class="rounded px-2 py-1 text-xs"
                      :class="{
                        'bg-[#136782] text-white': true, // TODO -- hardcoded
                        'bg-[#136782] text-white': loadRate === 'Great Deal',
                        'bg-[#18A5CB] text-white': loadRate === 'Good Deal',
                        'bg-[#2AC6E8] text-neutral-boldest':
                          loadRate === 'Fair Deal',
                        'bg-green-500': loadRate === 'Above Market',
                        'bg-red-100 text-red-600': loadRate === 'Below Market',
                      }"
                      >{{ loadRate }}</span
                    >
                    <div class="flex items-end gap-1">
                      <h3 class="text-3xl font-semibold">
                        {{ formatPrice(load.price) }}
                      </h3>
                      <p
                        v-if="ratePerMile"
                        class="mb-[6px] w-max text-2xs text-neutral-subtlest"
                      >
                        {{ formatPrice(lane_prediction?.target_buy_rate) }}/mi
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="!isDesktop"
                    class="flex justify-between"
                  >
                    <!-- <div>
                    <a
                      :href="`/broker/carriers/${load?.carrier?.id}`"
                      target="_blank"
                      class="load-highway-badge flex gap-2"
                    >
                      <img
                        v-if="brokerLogo"
                        class="flex h-8 items-center text-2xs"
                        :src="brokerLogo"
                        alt="broker logo"
                      />
                      <div
                        v-else
                        class="h-2"
                      ></div>
                    </a>

                    <p
                      class="mb-2 text-left text-1xs font-normal text-neutral-subtlest"
                    >
                      This load is eligible for an Advance and QuickPay
                    </p>
                  </div> -->

                    <div class="flex flex-col items-start">
                      <span
                        class="rounded px-2 py-1 text-xs"
                        :class="{
                          'bg-[#136782] text-white': true, // TODO -- hardcoded
                          'bg-[#136782] text-white': loadRate === 'Great Deal',
                          'bg-[#18A5CB] text-white': loadRate === 'Good Deal',
                          'bg-[#2AC6E8] text-neutral-boldest':
                            loadRate === 'Fair Deal',
                          'bg-green-500': loadRate === 'Above Market',
                          'bg-red-100 text-red-600':
                            loadRate === 'Below Market',
                        }"
                        >{{ loadRate }}</span
                      >

                      <div class="flex items-end gap-2 pt-2">
                        <h3 class="text-3xl font-semibold">
                          {{ formatPrice(load.price) }}
                        </h3>
                        <p
                          v-if="ratePerMile"
                          class="-mt-2 text-1xs text-neutral-subtlest"
                        >
                          {{ formatPrice(lane_prediction?.target_buy_rate) }}/mi
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="my-4 flex items-center justify-between">
                    <!-- <a
                    v-if="isDesktop"
                    :href="`/broker/carriers/${load?.carrier?.id}`"
                    target="_blank"
                    class="flex items-center justify-center gap-2"
                  >
                    <HighwayConnectBadge
                      :is-carrier-registered="load?.carrier?.is_registered"
                    ></HighwayConnectBadge>

                    <img
                      v-if="brokerLogo"
                      class="flex h-8 max-w-48 items-center text-2xs"
                      :src="brokerLogo"
                      alt="broker logo"
                    />
                  </a> -->

                    <div class="flex gap-1">
                      <img
                        src="@/assets/loads/map.svg"
                        alt="map icon"
                      />
                      <p class="text-xs sm:text-sm">
                        {{ billableMiles }}mi Trip
                      </p>
                    </div>

                    <div class="flex items-center gap-1">
                      <img
                        class="h-5 w-5"
                        src="@/assets/loads/destination-marker.svg"
                        alt="destination icon"
                      />
                      <p class="text-xs sm:text-sm">{{ numberOfStops }}</p>
                    </div>

                    <div class="flex items-center gap-1 sm:gap-2">
                      <img
                        class="h-4 w-4"
                        src="@/assets/phone-arrow.svg"
                        alt="phone icon"
                      />
                      <a
                        v-if="formattedPhone"
                        class="text-xs sm:text-sm"
                        :href="`tel:+${load.broker_phone_number}`"
                      >
                        {{ formattedPhone }}
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>

                  <img
                    class="mb-4 mt-2 text-2xs"
                    src="@/assets/loads/triumph-intelligence.svg"
                    alt="triumph logo"
                  />

                  <div
                    v-if="lane_prediction"
                    class="mb-8 mt-1"
                  >
                    <div class="mb-2 flex justify-between">
                      <div>
                        <p class="text-sm font-normal text-neutral-subtlest">
                          Low: {{ formatPrice(lane_prediction?.low_buy_rate) }}
                        </p>
                      </div>
                      <div>
                        <p class="text-sm font-normal text-neutral-subtlest">
                          High:
                          {{ formatPrice(lane_prediction?.high_buy_rate) }}
                        </p>
                      </div>
                    </div>

                    <div class="relative flex gap-[2px]">
                      <span
                        v-if="isBelowMarket"
                        class="flex h-4 w-1/12 rounded-l-md bg-red-500"
                      ></span>
                      <span
                        class="flex h-4 w-2/12 bg-[#2AC6E8]"
                        :class="{
                          'rounded-l-md': !isBelowMarket,
                        }"
                      ></span>
                      <span
                        class="flex h-4 bg-[#18A5CB]"
                        :class="
                          isBelowMarket || isAboveMarket ? 'w-7/12' : 'w-8/12'
                        "
                      ></span>
                      <span
                        class="flex h-4 w-2/12 bg-[#136782]"
                        :class="{
                          'rounded-r-md': !isAboveMarket,
                        }"
                      ></span>
                      <span
                        v-if="isAboveMarket"
                        class="flex h-4 w-1/12 rounded-r-md bg-green-900"
                      ></span>

                      <div
                        class="absolute -bottom-6 flex flex-col items-center"
                        :style="`left: calc(${targetRatePercentage}% - 19px)`"
                      >
                        <img
                          class="h-5 w-5"
                          src="@/assets/loads/orange-arrow.svg"
                          alt="arrow"
                        />
                        <p class="text-sm leading-none">
                          Rate:
                          {{ formatPrice(lane_prediction?.target_buy_rate) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="mb-6 mt-4 flex flex-col items-start gap-2">
                    <div
                      class="flex items-center rounded-lg bg-light-gray px-2 py-1 text-sm font-normal text-neutral-subtle"
                    >
                      <img
                        class="mr-2 h-5 w-5"
                        src="@/assets/loads/load-pay.svg"
                        alt="triumph logo"
                      />
                      Cash Advance - 3.5%
                    </div>
                    <div
                      class="flex items-center rounded-lg bg-light-gray px-2 py-1 text-sm font-normal text-neutral-subtle"
                    >
                      <img
                        class="mr-2 h-5 w-5"
                        src="@/assets/loads/triumph-logo-blue.svg"
                        alt="triumph logo"
                      />
                      QuickPay - 2.5%
                    </div>
                  </div>
                </div>

                <div
                  v-if="isLoadBoard && isDesktop"
                  class="mt-4 rounded-lg border border-light-gray p-3"
                >
                  <p class="pb-2 text-left text-xl font-medium">Details</p>

                  <!-- TODO -- hardcoded info -->
                  <div class="flex flex-col gap-1.5 pb-2">
                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest">Post Age</p>
                      <p class="text-neutral-subtle-bold">
                        {{ fromNowFirstUnit(load.last_posted_at) }}
                      </p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest">Weight</p>
                      <p class="text-neutral-subtle-bold">{{ loadWeight }}</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest">Commodity</p>
                      <p class="text-neutral-subtle-bold">
                        {{ load?.posted_commodity_type || 'Paper Towels' }}
                      </p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest">Certifications</p>
                      <p class="text-neutral-subtle-bold">None</p>
                    </div>

                    <div
                      v-if="load?.comments"
                      class="flex flex-col items-start gap-2"
                    >
                      <p class="text-neutral-subtlest">Special Instructions</p>
                      <p class="text-left text-neutral-subtle-bold">
                        {{ load?.comments }}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  v-if="isLoadBoard && isDesktop"
                  class="mt-4 flex flex-col"
                >
                  <div class="rounded-lg border border-light-gray p-3">
                    <p class="mb-2 text-left text-xl font-medium">Equipment</p>

                    <div class="mb-2 flex flex-col gap-2 font-normal">
                      <div class="col-span-3 flex items-center justify-between">
                        <p class="text-neutral-subtlest">Load Type</p>

                        <!-- TODO -- hardcoded -->
                        <p class="text-neutral-subtle-bold">LTL</p>
                      </div>

                      <div class="col-span-3 flex items-center justify-between">
                        <p class="text-neutral-subtlest">Truck Type</p>

                        <p class="capitalize text-neutral-subtle-bold">
                          {{
                            formatEquipmentType(
                              load?.posted_equipment_types?.[0]
                            ) || 'Power Only'
                          }}
                        </p>
                      </div>

                      <div class="col-span-3 flex items-center justify-between">
                        <p class="text-neutral-subtlest">Length</p>

                        <p class="text-neutral-subtle-bold">
                          {{ trailerLength }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4">
                    <div
                      v-for="(stop, stopIndex) in load.stops"
                      :key="stop.id"
                      class="border border-light-gray p-3"
                      :class="{
                        'rounded-t-lg': stopIndex === 0,
                        'rounded-b-lg': stopIndex === load.stops?.length - 1,
                      }"
                    >
                      <p class="mb-2 text-left text-xl font-medium">
                        Stop {{ stopIndex + 1 }}
                      </p>

                      <div class="flex flex-col gap-2 font-normal">
                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Type</p>

                          <p
                            class="text-neutral-subtle-bold"
                            v-if="!stopIndex"
                          >
                            Loading
                          </p>
                          <p
                            class="text-neutral-subtle-bold"
                            v-else
                          >
                            Unloading
                          </p>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Location</p>

                          <p class="text-neutral-subtle-bold">
                            {{ formattedCityStateAddress(stop) }}
                          </p>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Appointment</p>

                          <p class="text-neutral-subtle-bold">
                            {{ formattedTime(stop) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="z-10 -mt-8 rounded-xl border border-light-gray bg-white p-4 shadow-md lg:mt-4"
              >
                <a
                  :href="`/broker/carriers/${load?.carrier?.id}`"
                  target="_blank"
                  class="flex items-center justify-center gap-2"
                >
                  <HighwayConnectBadge
                    :is-carrier-registered="load?.carrier?.is_registered"
                  ></HighwayConnectBadge>

                  <img
                    v-if="brokerLogo"
                    class="flex h-8 items-center text-2xs"
                    :src="brokerLogo"
                    alt="broker logo"
                  />
                </a>

                <div class="mt-4 flex items-center justify-around">
                  <div class="flex gap-1">
                    <img
                      src="@/assets/loads/map.svg"
                      alt="map icon"
                    />
                    <p class="text-xs">{{ billableMiles }}mi Trip</p>
                  </div>
                  <div class="flex items-center gap-1">
                    <img
                      class="h-5 w-5"
                      src="@/assets/loads/destination-marker.svg"
                      alt="destination icon"
                    />
                    <p class="text-xs">{{ numberOfStops }}</p>
                  </div>
                  <!-- <div class="flex gap-1">
                    <img
                      src="@/assets/phone-arrow.svg"
                      alt="phone icon"
                    />
                    <a
                      class="text-xs"
                      href="tel:+1234567890"
                      >{{ formattedPhone }}</a
                    >
                  </div> -->
                </div>
              </div>

              <div
                v-if="isLoadBoard && !isDesktop"
                :class="{
                  'flex flex-col gap-1.5 rounded-xl border border-light-gray bg-white py-2 shadow-md lg:mt-4':
                    !isDesktop,
                }"
              >
                <p
                  class="border-gray border-b pb-2 pl-4 text-left text-xl font-medium"
                >
                  Details
                </p>

                <!-- TODO -- hardcoded info -->
                <div class="flex flex-col gap-1.5 px-4 pb-2">
                  <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Post Age</p>
                    <p class="text-neutral-subtle-bold">
                      {{ fromNowFirstUnit(load.last_posted_at) }}
                    </p>
                  </div>

                  <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Weight</p>
                    <p class="text-neutral-subtle-bold">{{ loadWeight }}</p>
                  </div>

                  <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Commodity</p>
                    <p class="text-neutral-subtle-bold">
                      {{ load?.posted_commodity_type || 'Paper Towels' }}
                    </p>
                  </div>

                  <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Certifications</p>
                    <p class="text-neutral-subtle-bold">None</p>
                  </div>

                  <div
                    v-if="load?.comments"
                    class="flex flex-col items-start gap-2"
                  >
                    <p class="text-neutral-subtlest">Special Instructions</p>
                    <p class="text-left text-neutral-subtle-bold">
                      {{ load?.comments }}
                    </p>
                  </div>
                </div>
              </div>

              <CollapsibleLoadDetails
                v-if="!isLoadBoard"
                title="Equipment"
              >
                <div
                  class="flex min-h-[175px] flex-col gap-2 border-t border-light-gray p-3 font-normal"
                >
                  <div
                    v-if="load?.carrier_vehicle?.id"
                    class="flex flex-col gap-1"
                  >
                    <div class="mb-2 flex gap-1">
                      <img
                        src="@/assets/blue-circle-check.svg"
                        alt="blue check"
                      />
                      <p class="text-xs font-semibold text-neutral-subtlest">
                        {{
                          assignedVehicle?.carrier_vehicle?.id
                            ? assignedVehicle?.carrier_vehicle_assigned_by
                              ? `${assignedVehicle?.carrier_vehicle?.is_uninsured_eld ? 'Unverified vehicle' : 'Vehicle'} assigned by ${assignedVehicle?.carrier_vehicle_assigned_by === 'tms' ? 'TMS' : capitalizeWords(assignedVehicle?.carrier_vehicle_assigned_by)}`
                              : ''
                            : 'No carrier vehicle assigned'
                        }}
                      </p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-gray-600">Truck Number</p>
                      <p>{{ load.carrier_vehicle?.id || '-' }}</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-gray-600">VIN</p>
                      <div>
                        <p>{{ load.carrier_vehicle?.vin || '-' }}</p>
                      </div>
                    </div>

                    <button-main
                      class="my-2 !w-max text-1md !text-dark-gray"
                      variant="tertiary"
                      @click="handleChangeVehicle"
                    >
                      Change Vehicle
                    </button-main>
                  </div>

                  <div
                    v-else
                    class="flex flex-col items-center gap-2"
                  >
                    <img
                      src="@/assets/alert-square.svg"
                      alt="alert icon"
                    />
                    <p>
                      No vehicle has been assigned to this load yet. Assign a
                      vehicle now to keep things moving.
                    </p>

                    <button-main
                      class="my-2 !max-w-[400px] text-1md !text-white"
                      variant="secondary"
                      custom-bg="#374053"
                      @click="openAssignVehicleBottomSheet"
                    >
                      Assign Vehicle
                    </button-main>
                  </div>
                </div>
              </CollapsibleLoadDetails>

              <div v-if="isLoadBoard && !isDesktop">
                <CollapsibleLoadDetails
                  v-for="(stop, stopIndex) in load.stops"
                  :key="stop.id"
                  :title="`Stop ${stopIndex + 1}`"
                  :badge-text="
                    isLoadBoard ? '' : stopStatus(load.stops, stopIndex)?.status
                  "
                  :badge-color="
                    isLoadBoard ? '' : stopStatus(load.stops, stopIndex)?.color
                  "
                  :className="{
                    'mb-4': stopIndex !== load.stops?.length - 1,
                  }"
                >
                  <div
                    class="flex flex-col gap-2 border-t border-light-gray p-3 font-normal"
                  >
                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">Type</p>
                      <p v-if="!stopIndex">Loading</p>
                      <p v-else>Unloading</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">
                        Address
                      </p>
                      <div class="flex flex-col items-end">
                        <p v-if="!isLoadBoard">
                          {{ formattedStreetAddress(stop) }}
                        </p>
                        <p>{{ formattedCityStateAddress(stop) }}</p>
                      </div>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">
                        Appointment
                      </p>
                      <p>
                        {{ formattedTime(stop) }}
                      </p>
                    </div>
                  </div>
                </CollapsibleLoadDetails>
              </div>

              <CollapsibleLoadDetails
                v-if="!isLoadBoard"
                title="Broker"
                :className="!isDesktop ? 'mb-24' : ''"
              >
                <div
                  class="flex flex-col gap-2 border-t border-light-gray p-3 font-normal"
                >
                  <div class="flex justify-between">
                    <p class="font-semibold text-neutral-subtle-bold">
                      {{ broker?.legal_name }}
                    </p>

                    <img
                      v-if="brokerLogo"
                      class="flex h-6 items-center text-2xs"
                      :src="brokerLogo"
                      alt="broker logo"
                    />
                  </div>

                  <div class="flex items-center justify-between">
                    <p class="text-neutral-sublest">Connected</p>

                    <div class="flex items-center gap-1">
                      <HighwayConnectBadge
                        :is-carrier-registered="load?.carrier?.is_registered"
                      ></HighwayConnectBadge>

                      <p
                        v-if="!load?.carrier?.is_registered"
                        class="text-2xs font-medium text-neutral-subtle-bold"
                      >
                        This carrier is not registered with Highway.
                      </p>
                      <p
                        v-else
                        class="text-sm font-medium text-neutral-subtle-bold"
                      >
                        You're connected
                      </p>
                    </div>
                  </div>
                </div>
              </CollapsibleLoadDetails>

              <div
                v-else
                class="flex flex-col gap-4"
                :class="{
                  'pb-24': !isDesktop,
                }"
              >
                <CollapsibleLoadDetails
                  v-if="isLoadBoard && !isDesktop"
                  title="Equipment"
                >
                  <div
                    class="flex flex-col gap-4 p-3 font-normal"
                    :class="{
                      'border-t border-light-gray': !isDesktop,
                    }"
                  >
                    <div
                      class="grid grid-cols-3 text-left"
                      :class="{
                        'gap-2': !isDesktop,
                      }"
                    >
                      <div
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Load Type
                        </p>
                        <p class="text-neutral-subtle-bold">LTL</p>
                      </div>

                      <div
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Truck Type
                        </p>
                        <!-- TODO --badge here -->
                        <p
                          class="w-max rounded-md bg-blue-200 px-2 capitalize text-blue-700 text-neutral-subtle-bold"
                        >
                          {{
                            formatEquipmentType(
                              load?.posted_equipment_types?.[0]
                            ) || 'Power Only'
                          }}
                        </p>
                      </div>

                      <div
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Length
                        </p>
                        <p class="text-neutral-subtle-bold">
                          {{ trailerLength }}
                        </p>
                      </div>
                    </div>
                  </div>
                </CollapsibleLoadDetails>

                <div v-if="showTriumphContainer">
                  <TriumphCollapsibleDetail
                    :lane-prediction="lane_prediction"
                  ></TriumphCollapsibleDetail>
                </div>

                <div v-if="isDesktop">
                  <div
                    class="grid grid-cols-3 rounded-lg border border-light-gray p-3 text-left"
                  >
                    <p class="mb-2 text-left text-xl font-medium">Broker</p>

                    <div class="col-span-3 flex items-center justify-between">
                      <p class="font-semibold text-neutral-subtlest">
                        {{
                          load.broker_name || load.order?.company?.legal_name
                        }}
                      </p>
                      <img
                        v-if="brokerLogo"
                        class="flex h-8 max-w-48 items-center text-2xs"
                        :src="brokerLogo"
                        alt="broker logo"
                      />
                    </div>

                    <div
                      class="col-span-1 col-span-3 flex !flex-row flex-col items-center justify-between gap-1"
                    >
                      <p class="text-neutral-subtlest">Connected</p>
                      <div class="flex items-center gap-1">
                        <!-- <HighwayConnectBadge
                          :is-carrier-registered="true"
                        ></HighwayConnectBadge> -->
                        <popper-badge
                          :highway-status="getHighwayStatus(load?.carrier)"
                          :connection-status="
                            canConnect !== true
                              ? null
                              : carrier.connection?.status !== undefined
                                ? carrier.connection?.status
                                : null
                          "
                          color-scheme="dark"
                        />

                        <p class="text-neutral-subtle-bold">You're Connected</p>
                      </div>
                    </div>

                    <div
                      class="col-span-3 mb-2 flex items-center justify-between"
                    >
                      <p class="text-neutral-subtlest">Phone Number</p>
                      <a
                        v-if="formattedPhone"
                        class="text-xs text-neutral-subtle-bold underline sm:text-gold"
                        :href="`tel:+${load.broker_phone_number}`"
                      >
                        {{ formattedPhone }}
                      </a>
                      <p v-else>-</p>
                    </div>

                    <div class="col-span-3 flex items-center justify-between">
                      <p class="text-neutral-subtlest">Email</p>
                      <a
                        :href="`mailto:${load.broker_email}`"
                        class="text-xs text-neutral-subtle-bold underline sm:text-gold"
                      >
                        {{ load.broker_email }}</a
                      >
                    </div>
                  </div>
                </div>
                <div v-else>
                  <CollapsibleLoadDetails title="Broker">
                    <div
                      class="flex flex-col p-3 font-normal sm:gap-4"
                      :class="{
                        'border-t border-light-gray': !isDesktop,
                      }"
                    >
                      <div class="grid grid-cols-3 gap-2 text-left">
                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="font-semibold text-neutral-subtlest">
                            {{
                              load.broker_name ||
                              load.order?.company?.legal_name
                            }}
                          </p>
                          <img
                            v-if="brokerLogo"
                            class="flex h-8 max-w-48 items-center text-2xs"
                            :src="brokerLogo"
                            alt="broker logo"
                          />
                        </div>

                        <div
                          class="col-span-1 col-span-3 flex !flex-row flex-col justify-between gap-1"
                        >
                          <p class="text-neutral-subtlest">Connected</p>
                          <div class="flex gap-1">
                            <HighwayConnectBadge
                              :is-carrier-registered="true"
                            ></HighwayConnectBadge>
                            <p class="text-neutral-subtle-bold">
                              You're Connected
                            </p>
                          </div>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Phone Number</p>
                          <a
                            v-if="formattedPhone"
                            class="text-xs text-neutral-subtle-bold underline sm:text-gold"
                            :href="`tel:+${load.broker_phone_number}`"
                          >
                            {{ formattedPhone }}
                          </a>
                          <p v-else>-</p>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Email</p>
                          <a
                            :href="`mailto:${load.broker_email}`"
                            class="text-xs text-neutral-subtle-bold underline sm:text-gold"
                          >
                            {{ load.broker_email }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </CollapsibleLoadDetails>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-2 flex gap-2"
            :class="{
              'fixed bottom-0 left-0 z-30 w-full bg-white px-4 pb-8 pt-4':
                !isDesktop,
              'sticky bottom-0 left-0 z-30 mt-4 w-full border-t border-light-gray bg-white py-6 pr-6':
                isDesktop,
            }"
          >
            <a
              v-if="load?.broker_phone_number"
              class="h-[48px] rounded-md bg-off-white py-3 text-1md text-dark-gray"
              :class="{
                'ml-auto !w-max px-4': isDesktop,
                'flex-1': !isDesktop,
              }"
              :href="`tel:+${load.broker_phone_number}`"
            >
              Contact Broker
            </a>
            <button-main
              class="!h-[48px] !py-3 text-1md !text-dark-gray"
              :class="{
                '!w-max px-4': isDesktop,
                'flex-1 !px-0': !isDesktop,
              }"
              @click="handleBookNow"
            >
              Book Now
            </button-main>
          </div>
        </div>

        <!-- history tab -->
        <div
          v-else
          class="mx-2 mt-4 min-h-[700px] rounded-md border-2 pb-12"
        >
          <div v-if="loadLogs?.length">
            <div class="flex w-full border-b-2 py-2 text-sm">
              <div class="flex-1">Date</div>
              <div class="flex-1">Location</div>
              <div class="flex-1">Update Type</div>
            </div>
            <div
              v-for="event in loadLogs"
              :key="event.id"
              class="flex w-full border-b-2 py-2 text-xs font-normal"
            >
              <div class="flex flex-1 justify-center gap-1">
                <svg
                  v-if="event.is_type === 'carrier_vehicle_assigned'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 6.93543 14.4169 5.92921 13.9732 5.03655L7.55889 11.4508L3.95215 7.84406L5.29901 6.4972L7.55889 8.75707L12.8693 3.4467C11.6527 2.14611 9.9211 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z"
                    fill="#F8C612"
                  />
                </svg>

                <svg
                  v-if="event.is_type === 'arrived_at_stop'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99967 14.6666C9.33301 14.6666 12.6663 8.57725 12.6663 5.99992C12.6663 3.42259 10.577 1.33325 7.99967 1.33325C5.42235 1.33325 3.33301 3.42259 3.33301 5.99992C3.33301 8.57725 6.66634 14.6666 7.99967 14.6666ZM7.99967 7.33325C8.73605 7.33325 9.33301 6.7363 9.33301 5.99992C9.33301 5.26354 8.73605 4.66659 7.99967 4.66659C7.26329 4.66659 6.66634 5.26354 6.66634 5.99992C6.66634 6.7363 7.26329 7.33325 7.99967 7.33325Z"
                    fill="#F8C612"
                  />
                </svg>

                <svg
                  v-if="event.is_type === 'departed_stop'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.6"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.99967 8.00008C2.99967 6.44688 4.06199 5.1418 5.49967 4.77176C5.23333 4.70321 4.95409 4.66675 4.66634 4.66675C2.82539 4.66675 1.33301 6.15913 1.33301 8.00008C1.33301 9.84103 2.82539 11.3334 4.66634 11.3334C4.95409 11.3334 5.23333 11.297 5.49967 11.2284C4.06199 10.8584 2.99967 9.55328 2.99967 8.00008ZM6.33301 8.00008C6.33301 6.44688 7.39532 5.1418 8.83301 4.77176C8.56666 4.70321 8.28742 4.66675 7.99967 4.66675C6.15873 4.66675 4.66634 6.15913 4.66634 8.00008C4.66634 9.84103 6.15873 11.3334 7.99967 11.3334C8.28742 11.3334 8.56666 11.297 8.83301 11.2284C7.39532 10.8584 6.33301 9.55328 6.33301 8.00008Z"
                    fill="#4285D7"
                  />
                  <ellipse
                    cx="11.3333"
                    cy="8.00008"
                    rx="3.33333"
                    ry="3.33333"
                    fill="#4285D7"
                  />
                </svg>

                <div class="text-left">
                  <div>
                    {{ getStopDay(event.occurred_at) }}
                  </div>
                  <div>{{ getStopTime(event.occurred_at, '', false) }}</div>
                </div>
              </div>

              <div class="flex-1 items-center capitalize">
                {{
                  event.carrier_vehicle_area?.carrier_vehicle_areas[0]
                    ?.description || ''
                }}
              </div>

              <div class="flex-1 items-center pr-2 capitalize">
                {{ event.external_message }}
              </div>
            </div>

            <div class="mb-4 mt-3 flex flex-col items-center">
              <span
                v-if="loadLogs?.length >= 10"
                class="cursor-pointer border-b-2 border-transparent text-sm text-gray-over-dark hover:border-gray-over-dark"
                @click="handleViewAll"
              >
                View {{ viewAllHistoryLogs ? 'less' : 'all' }}
              </span>
            </div>
          </div>

          <div v-else>
            <p class="mt-4 px-4 text-start text-base italic text-gray-200">
              No load events have been logged.
            </p>
          </div>
        </div>
      </div>

      <LoadDetailMap
        v-if="!loadDetailsLoading && isDesktop"
        :isDesktop="isDesktop"
        :load="load"
      ></LoadDetailMap>
    </div>

    <AssignVehicleBottomSheet
      :visible="showAssignVehicleBottomSheet"
      @close="closeAssignVehicleBottomSheet"
    >
    </AssignVehicleBottomSheet>

    <FactoringBottomSheet
      :visible="showFactoringBottomSheet"
      @close="closeFactoringBottomSheet"
    >
    </FactoringBottomSheet>
  </banners>
</template>

<script>
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Banners from '@/components/Banners.vue';
import ButtonMain from '@/components/Button.vue';
import CollapsibleLoadDetails from '@/components/loads/CollapsibleLoadDetails.vue';
import LoadDetailMap from '@/components/loads/LoadDetailMap.vue';
import HighwayConnectBadge from '@/components/HighwayConnectBadge.vue';
import TriumphCollapsibleDetail from '@/components/loads/TriumphCollapsibleDetail.vue';
import AssignVehicleBottomSheet from '@/components/loads/AssignVehicleBottomSheet.vue';
import FactoringBottomSheet from '@/components/loads/FactoringBottomSheet.vue';
import PopperBadge from '@/components/PopperBadge.vue';
import { useScreenSize } from '@/composables/useScreenSize';
import { formatPhoneParenthesis } from '@/common/validators.js';
import { fromNowFirstUnit } from '@/common/timestamps';
import { formatPrice } from '@/utils/currency.js';
import {
  getAppointmentDate,
  getStopDay,
  getStopTime,
} from '@/utils/loadTime.js';
import {
  formattedStreetAddress,
  formattedCityStateAddress,
  formatLoadStatus,
  formatEquipmentType,
  capitalizeWords,
} from '@/utils/loadBoardUtils.js';

export default {
  name: 'Load Detail View',
  components: {
    Banners,
    ButtonMain,
    CollapsibleLoadDetails,
    LoadDetailMap,
    HighwayConnectBadge,
    AssignVehicleBottomSheet,
    TriumphCollapsibleDetail,
    FactoringBottomSheet,
    PopperBadge,
  },
  data() {
    return {
      tabs: [
        {
          title: 'Details',
        },
        {
          title: 'History',
        },
      ],
    };
  },
  methods: {
    formattedTime(stop) {
      const { time, day } = getAppointmentDate(stop);

      return `${day}, ${time}`;
    },
    wasLoadCreatedAfterStopAppt(stop) {
      if (stop.scheduled_window_ended_at_in_stop_timezone) {
        return (
          Date.parse(stop.created_at) >
          Date.parse(stop.scheduled_window_ended_at_in_stop_timezone)
        );
      }
      return false;
    },
    hasIncompleteStopAddress(stop) {
      if (stop.street1?.length) {
        return false;
      }
      return true;
    },
    stopStatus(stops, index) {
      const stop = stops[index];

      if (stop.departed_at_in_stop_timezone) {
        return { status: 'Departed', color: 'green' };
      } else if (stop.arrived_at_in_stop_timezone) {
        return { status: 'Arrived', color: 'green' };
      } else if (this.wasLoadCreatedAfterStopAppt(stop)) {
        return {
          // status: 'Unknown Stop Status: Load Data Received Late',
          status: 'Unknown Stop Status',
          color: 'gray',
        };
      } else if (this.hasIncompleteStopAddress(stop)) {
        return {
          // status: 'Unknown Stop Status: No Street Address Provided',
          status: 'Unknown Stop Status',
          color: 'gray',
        };
      } else if (
        (index === 0 &&
          !stops[index + 1].arrived_at_in_stop_timezone &&
          !stops[index + 1].departed_at_in_stop_timezone) ||
        (index !== 0 &&
          (stops[index - 1].departed_at_in_stop_timezone ||
            this.wasLoadCreatedAfterStopAppt(stops[index - 1])))
      ) {
        return { status: 'En Route', color: 'light-blue' };
      } else {
        return { status: 'Not Started', color: 'gray' };
      }
    },
    getHighwayStatus(carrier) {
      // TODO hardcoded
      if (
        carrier?.carrier_company_id !== null &&
        carrier?.carrier_company_id > 0
      ) {
        return 'Connected';
      } else {
        return 'Connected';
      }
    },
    canConnect() {
      return (
        this.$store.state.users?.currentUser?.company?.company_type ==
          'broker' && this.$store.state.users?.currentUser?.paywall?.can_connect
      );
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    // const toast = useToast();
    const { screenSize } = useScreenSize();

    const isLoading = ref(false);
    const currentTab = ref('Details');

    const isLoadBoard = computed(() =>
      router.currentRoute.value?.path?.includes('load-board')
    );

    const showAssignVehicleBottomSheet = ref(false);
    const isDesktop = computed(() => screenSize.value === 'desktop');

    const openAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = true;
    };

    const closeAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = false;
    };

    const showFactoringBottomSheet = ref(false);
    const openFactoringBottomSheet = () => {
      showFactoringBottomSheet.value = true;
    };
    const closeFactoringBottomSheet = () => {
      showFactoringBottomSheet.value = false;
    };

    // TODO - revisit this
    const backUrl = isLoadBoard?.value
      ? '/carrier/load-board'
      : '/carrier/loads';
    // const backUrl =
    //   router.options.history.state.back ||
    //   (isLoadBoard?.value ? '/carrier/load-board' : '/carrier/loads');

    onBeforeMount(async () => {
      isLoading.value = true;

      const loadId = parseInt(router?.currentRoute?.value?.params?.id);

      let res;
      if (isLoadBoard?.value) {
        res = await store.dispatch('loads/getLoadBoardDetail', {
          id: loadId,
        });
      } else {
        res = await store.dispatch('loads/getLoadDetail', {
          id: loadId,
        });
        await store.dispatch('loads/getAssignedVehicle', loadId);
        await store.dispatch('loads/getLoadLogs', {
          id: loadId,
        });
      }

      if (isLoadBoard.value) {
        if (!res?.data?.can_be_posted) {
          // load detail not found
          // route to load board
          // toast.open({
          //   message: 'Invalid Load Posting',
          //   duration: 5000,
          //   dismissible: true,
          //   position: 'top-right',
          // });
          // router.push({
          //   name: 'Load Board',
          // });
        }
      }

      // TODO -- temporary open bottom sheet
      // if (res?.data?.broker_name === 'C.H. Robinson') {
      //   showFactoringBottomSheet.value = true;
      // }

      const company_id = res?.data?.order?.company_id;
      await store.dispatch('brokers/getCompanyById', company_id);

      isLoading.value = false;
    });

    const load = computed(() => store.state.loads.load_details);
    const loadDetailsLoading = computed(
      () => store.state.loads.isLoadDetailsLoading
    );
    const assignedVehicle = computed(() => store.state.loads.assigned_vehicle);

    const viewAllHistoryLogs = ref(false);

    const handleViewAll = () => {
      viewAllHistoryLogs.value = !viewAllHistoryLogs.value;
    };

    const fallback_prediction = computed(() => ({
      target_buy_rate: 1.749,
      start_buy_rate: 1.5002,
      low_buy_rate: 1.643,
      high_buy_rate: 1.871,
      fuel_rate: 0.39,
      distance: 666.567,
      confidence_level: 87,
      currency: 'USD',
      adjusted_rate_per_mile: 0.4484723918918919,
    }));

    const lane_prediction = computed(
      () => load?.value?.lane_prediction || fallback_prediction?.value
    );

    const showTriumphContainer = computed(
      () =>
        store.state.users.featureFlags?.load_board_triumph_container?.enabled &&
        load?.value?.lane_prediction
    );

    const loadLogs = computed(() => {
      if (viewAllHistoryLogs.value) {
        return store.state.loads.load_logs;
      } else {
        return store.state.loads.load_logs.slice(0, 10);
      }
    });

    const broker = computed(() => store.state.brokers?.company);
    // const brokerLogo = computed(() => load?.value?.broker_logo?.url);
    const brokerLogo = computed(() => {
      if (load?.value?.broker_name === 'WWEX Group') {
        return 'https://highway-prod-monitor.s3.amazonaws.com/6sxe224o6nv3xvwwmh3odrdajdfm?response-content-disposition=inline%3B%20filename%3D%22WWEXGroup_GTM_Navy.png%20FOR%20USE.png%22%3B%20filename%2A%3DUTF-8%27%27WWEXGroup_GTM_Navy.png%2520FOR%2520USE.png&response-content-type=image%2Fpng&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA5TETHIMSP4TR2AXM%2F20250528%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250528T134438Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEK7%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJIMEYCIQDot1sCYdPmdLXl8sqf4AtP0A7VnfMhQ73IZikhCIkjlwIhALvVBHdkM%2BoScExMe7XQWQk9CI%2FrouxYGJdB4gZX9HNRKu8DCHcQAhoMOTM0NDY0MTQ0MTY0Igx2%2FD43i1qiI5yDKyAqzAPvS3JB2sFf%2FSLASNGpuBJXCPEcntIoArdmgrwvC1idwxxrkg8AJcx45CybhEctnKPghZVrIR2tNukzndw%2Fwzv5NVmsRHwQNUPdswCPaIgpDnOg6P9Ob%2FU9wMULIpEbWQ3MqM9JPyhxu5UCired1R0auqgLEA3f5lVxGXFadXTwb1yUljXU%2BhNirVWQHkUezfVkUzoktylXVJHPzS9QrJES6LSg8FU8mUGaBe3MjZJYE8laVuqvuCqdEvaZGRWmEXza%2BUDB2KYsCGGvwCphFYyqTeOIzKP9mf6PFeAQa6dgAjgoX3ooF%2Ff9HEAwp4QAcN0P9%2FJXvRNX5vGXR6R0l66wiSEijnsOzNzl7xG75NSpWSTAOEMfiOHdqPUpTF9Tr5GRzTnxemz4JmzGdViJXlt9%2Bmn7Myrwe%2FOG6y1V%2FiUinAUE%2BTfsBrqwIt%2BEszUmhwEjBhfaMYFRGHW4wFq4xNy1r6wYYLhq34OjuulSQ2ySmLFolnWPTmgMWdox5wTtAXBvTI7FR9YqonWS%2FCGBYXYfbRpw9JyWNhzx1i%2FUJezrjfjLzMjrRa8Jj9zDF4v3e52BF3oBHIr2PiLfAyPDWXWVWEFHGxotOxRrnpidMJuc3MEGOqQBkrvicw5Ud1N%2FY6hYeSx%2FI8Rrutdij2UhJaoS3qf%2FodgLau9R5XT6ZR2YTygV5JA2%2FtBWJoqPXBuUymi3u5xKAK0qKiieZsduBloPf9Hfed34NiasbQ5Af1UQLvjofjQWyIFem8IlaQyBU6%2BLsLfs43MN%2B5i0JSWhAgWfCUPBCpkuuibyG8E9Ntq7Q7lfFimbR7QXzqfCTI0hgNIfD51NVEdWZ%2FE%3D&X-Amz-SignedHeaders=host&X-Amz-Signature=9a498249ca4e60823502820185fcdc2ed206d75ff814353ee0e35e6aaaccd688';
      }

      return load?.value?.broker_logo?.url;
    });

    const billableMiles = computed(() => {
      const totalMiles =
        lane_prediction?.value?.distance || load?.value?.billable_miles;

      return Math.round(totalMiles * 100) / 100;
    });

    const formattedPhone = computed(() => {
      return formatPhoneParenthesis(load?.value?.broker_phone_number);
    });

    const numberOfStops = computed(() => {
      if (load?.value?.stops?.length === 0) {
        return '';
      } else if (load?.value?.stops?.length === 1) {
        return '1 Stop';
      } else {
        return `${load?.value?.stops?.length} Stops`;
      }
    });

    const handleTabSelection = async (tab) => {
      isLoading.value = true;
      currentTab.value = tab;

      // await store.dispatch('loads/getLoadDetail', {
      //   query: loadQuery[tab],
      //   status: loadStatus[tab],
      // });
      isLoading.value = false;
    };

    // Carrier is onboarded, IDV'd, has connected ELD, but not connected to broker
    // When they click "Book Now" they are redirected to complete onboarding
    const handleBookNow = () => {
      console.log('Book Now');

      router.push({
        name: 'Book Now',
      });
    };

    const handleChangeVehicle = () => {
      console.log('Change Vehicle');
    };

    const ratePerMile = computed(() => {
      if (
        !lane_prediction?.value?.adjusted_rate_per_mile ||
        load?.value?.rate_pre_mile
      ) {
        return null;
      }
      return formatPrice(
        lane_prediction?.value?.adjusted_rate_per_mile ||
          load?.value?.rate_pre_mile
      );
    });

    const loadRate = computed(() => {
      // Something like this will be returned when it's available
      // return load?.value?.lane_prediction?.rate

      return 'Great Deal';
    });

    const weightUnit = {
      pound: 'lbs',
      kilogram: 'kg',
    };

    const loadWeight = computed(
      () =>
        `${load?.value?.weight?.toLocaleString('en-US')} ${weightUnit[load?.value?.weight_unit]}`
    );

    const lengthUnit = {
      inch: '"',
      foot: "'",
      meter: 'm',
    };

    const trailerLength = computed(
      () =>
        `${load?.value?.trailer_length}${lengthUnit[load?.value?.trailer_length_unit]}`
    );

    const targetRatePercentage = computed(() => {
      const { low_buy_rate, high_buy_rate, target_buy_rate } =
        lane_prediction?.value || {};

      if (high_buy_rate === low_buy_rate) return 0; // avoid division by zero
      const percentage =
        ((target_buy_rate - low_buy_rate) / (high_buy_rate - low_buy_rate)) *
        100;
      return Math.max(0, Math.min(100, percentage)); // clamp between 0 and 100
    });

    // TODO -- update when available
    const isBelowMarket = computed(() => {
      const { low_buy_rate, target_buy_rate } = lane_prediction?.value || {};

      if (target_buy_rate < low_buy_rate) {
        return true;
      }

      return false;
    });

    const isAboveMarket = computed(() => {
      const { high_buy_rate, target_buy_rate } = lane_prediction?.value || {};

      if (target_buy_rate > high_buy_rate) {
        return true;
      }

      return false;
    });

    return {
      backUrl,
      load,
      loadLogs,
      handleViewAll,
      viewAllHistoryLogs,
      broker,
      brokerLogo,
      billableMiles,
      assignedVehicle,
      formattedPhone,
      numberOfStops,
      isLoading,
      currentTab,
      handleTabSelection,
      showAssignVehicleBottomSheet,
      openAssignVehicleBottomSheet,
      closeAssignVehicleBottomSheet,
      showFactoringBottomSheet,
      openFactoringBottomSheet,
      closeFactoringBottomSheet,
      getStopDay,
      getStopTime,
      isDesktop,
      isLoadBoard,
      handleBookNow,
      handleChangeVehicle,
      formatPrice,
      fromNowFirstUnit,
      ratePerMile,
      loadRate,
      loadWeight,
      trailerLength,
      formattedStreetAddress,
      formattedCityStateAddress,
      formatLoadStatus,
      formatEquipmentType,
      capitalizeWords,
      loadDetailsLoading,
      targetRatePercentage,
      isBelowMarket,
      isAboveMarket,
      showTriumphContainer,
      lane_prediction,
    };
  },
};
</script>
